var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { getCookie } from './env';
import { generateResultImage } from "./image-handler";
import { uploadVideo, uploadImage } from '../x-world';
import { getImageInstance } from './image-auto-crop';
const PUBLISH_URL = 'https://h5.qzone.qq.com/v2/wezone/web/trpc?trpcProxyName=ComWriterProxy&trpcCommandName=PublishFeed';
const ADD_WHITELIST_URL = 'https://h5.qzone.qq.com/v2/wezone/web/act101';
/**
 * 保存视频(仅手Q端可用)
 * @param videoUrl 视频链接
 * @returns
 */
export const saveQQVideo = (videoUrl, cb) => {
    if (!videoUrl || !window.mqq)
        return;
    const param = {
        url: videoUrl,
        vid: videoUrl,
    };
    window.mqq.invoke('Qzone', 'videoProxySaveVideoToAlbum', param, cb);
};
/**
 * 保存图片
 */
export const saveQQImage = (imgUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const imgBase64 = imgUrl.indexOf('https') > -1 ? yield generateResultImage(imgUrl) : imgUrl;
    if (!imgUrl || !window.mqq)
        return;
    window.mqq.invoke('media', 'saveImage', {
        content: imgBase64,
    }, (data) => {
        if (data.retCode === 0) {
            window.mqq.invoke('ui', 'showTips', {
                text: '图片保存成功',
                iconMode: 1,
            });
        }
        else {
            window.mqq.invoke('ui', 'showTips', {
                text: '图片保存失败，请稍后再试',
                iconMode: 2,
            });
        }
    });
});
/**
 * 隐藏QQ内右上角分享按钮
 */
export function hideShareBtn() {
    var _a, _b;
    (_b = (_a = window.mqq) === null || _a === void 0 ? void 0 : _a.ui) === null || _b === void 0 ? void 0 : _b.setWebViewBehavior({
        actionButton: 0
    });
}
/**
 * QQ小世界发表
 */
export const publishQQWorld = (params) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { videoUrl, content, imageUrl, materialId } = params;
    // 获取发表小世界参数
    const { videoId, videoSize, posterUrl, posterHeight, posterWidth } = yield getPublishWorldParams({
        videoUrl,
        imageUrl,
    });
    console.log(videoId, videoSize, posterUrl, posterHeight, posterWidth);
    const uin = getUinHeaders();
    const H5_UP_SOURCE = '101';
    const requestData = {
        extInfo: {
            mapInfo: [
                {
                    key: 'up_source',
                    value: H5_UP_SOURCE
                }
            ]
        },
        feed: {
            poster: {
                id: uin['x-uin']
            },
            cover: {
                width: posterWidth,
                height: posterHeight,
                picUrl: posterUrl
            },
            video: {
                fileId: videoId,
                fileSize: videoSize,
                transStatus: 2,
                materialList: [
                    {
                        materialType: 'template',
                        materialList: [
                            {
                                materialId,
                            }
                        ]
                    }
                ]
            },
            content,
            type: 3,
            createTime: +new Date(),
            syncStatus: 0
        }
    };
    const res = yield axios.post(PUBLISH_URL, requestData, {
        headers: {
            'trpc-header': JSON.stringify({
                "sw-plugin-qua": "V1_AND_SQ_8.8.28_2092_YYB_D_A_8082800",
            })
        }
    });
    if (((_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.code) !== 0) {
        throw new Error('发布失败');
    }
    // 发布完成自动开启小世界白名单
    yield addXWorldWhitelist();
});
/**
 * 自动开启 手Q小世界 白名单
 */
export function addXWorldWhitelist() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield axios.get(ADD_WHITELIST_URL);
        }
        catch (e) {
            console.error(e);
        }
    });
}
function getUinHeaders() {
    const qqUin = getCookie('uin');
    if (!qqUin)
        return {};
    return {
        'x-uin': `${parseInt(qqUin.slice(1))}`
    };
}
/**
 * 获取发表小世界需要的参数
 * 上传视频
 * 上传封面图
 */
export const getPublishWorldParams = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { videoUrl, imageUrl } = params;
    // 获取上传的视频id
    const { file, biz } = yield uploadVideo(videoUrl);
    // 获取上传的图片url
    const imageResult = yield uploadImage(imageUrl, biz.sVid);
    // 获取封面图片宽高
    const { width, height } = yield getImageInstance(imageUrl);
    return {
        videoId: biz.sVid,
        videoSize: file.size,
        posterUrl: imageResult.biz.sAdaptUrl_1000,
        posterWidth: width,
        posterHeight: height,
    };
});
